export default __webpack_public_path__ + "static/media/6-tree.609e8279.png";